/**
 * author: Patrick Vyn Badiang
 */
import { useEffect } from "react";
import "../Pages/FormsPage/FormsPage.css";

export default function Calendar() {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://embed.styledcalendar.com/assets/parent-window.js';
        script.async = true;
        script.type = 'module';
        document.body.appendChild(script);
    
        // Clean up the script when the component is unmounted
        return () => {
          document.body.removeChild(script);
        };
      }, []);
    
      return (
        // <div className="calendar-container">
          <iframe
            src="https://embed.styledcalendar.com/#PnL4TnUPFRuv5vCK8gjl"
            title="Styled Calendar"
            className="styled-calendar-container"
            style={{ width: "100%", height: "700px", aspectRatio: "1",border: "none" }}
            data-cy="calendar-embed-iframe"
          ></iframe>
        // </div>
      );
}
